import { useContext } from 'react';

import { TwitchConstants } from '@/constants/twitch-constants';
import { Context } from '@/context';

import Tiktok from './icons/tiktok';
import { Box, Typography, keyframes } from '@mui/material';
import Twitch from './icons/twitch';

const twitchBlink = keyframes`
  0%, 100% {
    background-color: #6441a5;
  }
  50% {
    background-color: #8b5cf6;
  }
`;

const twitchBlinkDark = keyframes`
  0%, 100% {
    background-color: #000000;
  }
  50% {
    background-color: #1a1a1a;
  }
`;

const TwitchLive = () => {
    const { state } = useContext(Context);
    const { configuration } = state;

    const styles = {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        px: 1,
        borderRadius: '4px',
        cursor: 'pointer',
    };

    const handleClick = () => {
        if (configuration?.twitchOption === TwitchConstants.LIVE) {
            window.open('https://www.twitch.tv/donquijotedlc', '_blank');
        } else if (configuration?.twitchOption === TwitchConstants.LIVE_KROMOW) {
            window.open('https://www.twitch.tv/kromow', '_blank');
        } else if (configuration?.twitchOption === TwitchConstants.LIVE_TIKTOK) {
            window.open('https://www.tiktok.com/@analitica.fantasy/live', '_blank');
        } else if (configuration?.twitchOption === TwitchConstants.LIVE_TERTULIA) {
            window.open('https://www.twitch.tv/fantasykingsofficial', '_blank');
        } else if (configuration?.twitchOption === TwitchConstants.LIVE_PYLON) {
            window.open('https://www.twitch.tv/plyontv10', '_blank');
        }
    };

    if (
        configuration?.twitchOption === TwitchConstants.LIVE ||
        configuration?.twitchOption === TwitchConstants.LIVE_KROMOW ||
        configuration?.twitchOption === TwitchConstants.LIVE_TERTULIA ||
        configuration?.twitchOption === TwitchConstants.LIVE_PYLON
    ) {
        return (
            <Box
                sx={{
                    ...styles,
                    backgroundColor: '#6441a5',
                    animation: `${twitchBlink} 2s ease-in-out infinite`,
                }}
                onClick={handleClick}
            >
                <Twitch color="#fff" />
                <Typography component="span" fontSize={12} color="#fff">
                    Live
                </Typography>
            </Box>
        );
    } else if (configuration?.twitchOption === TwitchConstants.LIVE_TIKTOK) {
        return (
            <Box className="container">
                <Box
                    sx={{
                        ...styles,
                        backgroundColor: '#000000',
                        marginBottom: '8px',
                        animation: `${twitchBlinkDark} 2s ease-in-out infinite`,
                    }}
                    onClick={handleClick}
                >
                    <Tiktok color="#fff" />
                    <Typography component="span" fontSize={12} color="#fff">
                        Live
                    </Typography>
                </Box>
            </Box>
        );
    }
};

export default TwitchLive;
